<template>
    <div class="badge-vanilla" @click="onClick">
        <div class="wrapper">
            <img class="icon" src="@/assets/images/app/vanilla_dark.svg" />
            <span class="vanilla">{{ vanilla }}</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'BadgeVanilla',
    computed: {
        vanilla() {
            return (this.$store.getters.badges || {}).vanilla
        },
    },
    methods: {
        onClick() {
            this.$emit('click')
        },
    },
}
</script>

<style lang="scss" scoped>
.badge-vanilla {
    overflow: hidden;
    border-radius: 6px;

    .wrapper {
        display: flex;
        align-items: center;
        color: $grey-08;
        font-size: 14px;

        @include f-medium;

        .icon {
            margin-right: 4px;
            text-align: center;
            display: inline-block;
            width: 20px;
            flex: none;
        }

        .vanilla {
            max-width: 40px;
            color: $grey-08;
            flex: auto;
        }
    }
}
</style>
